<div class="discount-offer">
    <div class="discount-chip" *ngIf="discountUnit != null && discount != null">
        <ng-container [ngSwitch]="discountUnit">
            <ng-container *ngSwitchCase="discountType.TEXT">
                <span>{{ discount }}</span>
            </ng-container>

            <ng-container *ngSwitchCase="discountType.CHF">
                <span> -{{ discount }}&nbsp;{{ swissCurrency }} </span>
            </ng-container>

            <ng-container *ngSwitchCase="discountType.Percentage">
                <span> -{{ discount }}{{ percentageSign }} </span>
            </ng-container>
        </ng-container>
    </div>

    <div class="logo" [ngStyle]="{ 'background-color': circularBubbleColorHexCode }">
        <img [src]="logoUrl" alt="logo" />
    </div>

    <img
        class="discount-offer-image"
        [ngClass]="{
            'discount-offer-image-with-no-background': imageType === imageTypes.NO_BG_IMAGE,
        }"
        src="{{ imageUrl }}"
        alt="discount-offer-image"
    />
</div>
